import { Navigate, useLocation } from 'react-router-dom';
import { tokenService } from '../../services';

export const ProtectedRoute = ({ children, isAllowed = true, redirectTo = '/dashboard/app' }) => {
  const location = useLocation();

  if (!tokenService.getUser()) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  if (!isAllowed) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};
